import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FlightClassCMS } from '../../models';

export const FlightClassSelectorItem = ({ value, onChange, isSelected }) => {
    const { t } = useTranslation();
    const onClick = () => onChange(value);
    const text = t(FlightClassCMS[value]);
    const className = `odf-text-md odf-text-nowrap odf-dropdown-item ${
        isSelected ? ' active' : ''
    }`;

    return (
        <li onClick={onClick} className={className}>
            {text}
        </li>
    );
};

FlightClassSelectorItem.propTypes = {
    value: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};
